import { SKILL_BUILDER_PROFILE_URL } from '@/src/constants/common';
import { RoutePath } from '@/src/RoutePath';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { SideNavigation } from '@amzn/awsui-components-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const JamProfileSideNav: React.FC = () => {
  const { t } = useTranslation();
  const [activeHref, setActiveHref] = React.useState(RoutePath.JAM_PROFILE_DETAILS.valueOf());
  const history = useHistory();

  const headerHref = RoutePath.JAM_PROFILE_DETAILS;

  const navigationItems = [
    {
      type: 'link' as const,
      text: `${t(i18nKeys.JamProfile.jamProfileDetails.title)}`,
      href: RoutePath.JAM_PROFILE_DETAILS,
    },
    {
      type: 'link' as const,
      text: `${t(i18nKeys.JamProfile.sbProfile)}`,
      href: SKILL_BUILDER_PROFILE_URL,
      external: true,
    },
  ];

  return (
    <div className="jam-profile-sidenav">
      <SideNavigation
        activeHref={activeHref}
        header={{ href: headerHref, text: `${t(i18nKeys.JamProfile.title)}` }}
        onFollow={(e) => {
          if (!e.detail.external) {
            e.preventDefault();
            setActiveHref(e.detail.href);
            history.push(e.detail.href);
          }
        }}
        items={navigationItems}
      />
    </div>
  );
};

export default JamProfileSideNav;
